import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import ClientLink from "./client-link";
import Flatpickr from "react-flatpickr"
import { getClientDeals, getClientDetail, getInClientDetail} from "../../store/clients/actions"


import "flatpickr/dist/themes/material_blue.css"
import Select from "react-select"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Input,
  Button,
  InputGroup
} from "reactstrap"
import { AvField, AvForm, AvCheckbox } from "availity-reactstrap-validation"
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import ClientInvestorBreadcrumbs from "components/Common/ClientInvestorBreadcrumb";
import ClientInvestorMenu from "./menu/client-investor-menu";
import NoAccess from "components/NoAccess";
import { API_URL } from "helpers/app_url";
import { projects } from "common/data";
import Moment from "react-moment";
import RsLink from "components/buttons/rsLink";
import SaveButton from "components/buttons/save";

class ClientActive extends Component {
  constructor(props) {
    super(props)
    this.state = {
        isLoading:false,
        isLoginDisable:false
    }
     
  }

  

  componentDidMount() {
    const { match: { params }, onGetClientDetail, onGetClientDeals} = this.props;
    onGetClientDetail(params.clientId);
    onGetClientDeals(localStorage.getItem('userId'), params.id)
   
   
}

deactivateClient(value) {
   this.setState({ isLoading: true });
    const { onGetInClientDetail } = this.props;
    const authUser = localStorage.getItem("authUser");
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;

    if (!token) return;

    const headers = {
        Authorization: `Bearer ${token}`
    };

    const payload = {
        id: parseInt(this.props.match.params.id),  
        isActive: false,
        isLoginActive: value.loginDisabled,
        agentId: localStorage.getItem('userId')

    };
    axios.post(`${API_URL}Client/InactiveClient`, payload, { headers })
        .then(response => {
            if (response.status === 200 && response.data.success) {
                this.setState({ isLoading: false });
                onGetInClientDetail(this.props.match.params.clientId);
            } else {
                console.warn('Deactivation failed:', response.data);
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
}

disableClientLogin(value) {
   this.setState({ isLoginDisable: true });
    const { onGetInClientDetail } = this.props;
    const authUser = localStorage.getItem("authUser");
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;

    if (!token) return;

    const headers = {
        Authorization: `Bearer ${token}`
    };

    const payload = {
        id: parseInt(this.props.match.params.id),  
        isActive: value.isActive,
        isLoginActive: false,
         agentId: localStorage.getItem('userId')

    };
    axios.post(`${API_URL}Client/InactiveClient`, payload, { headers })
        .then(response => {
            if (response.status === 200 && response.data.success) {
                this.setState({ isLoginDisable: false });
                onGetInClientDetail(this.props.match.params.clientId);
            } else {
                console.warn('Deactivation failed:', response.data);
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
}


activeClient(value) {
   this.setState({ isLoading: true });
    const { onGetInClientDetail } = this.props;
    const authUser = localStorage.getItem("authUser");
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;

    if (!token) return;

    const headers = {
        Authorization: `Bearer ${token}`
    };

    const payload = {
        id: parseInt(this.props.match.params.id),  
        isActive: true,
        isLoginActive: value.loginDisabled,
         agentId: localStorage.getItem('userId')

    };
    axios.post(`${API_URL}Client/InactiveClient`, payload, { headers })
        .then(response => {
            if (response.status === 200 && response.data.success) {
                this.setState({ isLoading: false });
                onGetInClientDetail(this.props.match.params.clientId);
            } else {
                console.warn('Deactivation failed:', response.data);
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
}

activeClientLogin(value) {
   this.setState({ isLoginDisable: true });
    const { onGetInClientDetail } = this.props;
    const authUser = localStorage.getItem("authUser");
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;

    if (!token) return;

    const headers = {
        Authorization: `Bearer ${token}`
    };

    const payload = {
        id: parseInt(this.props.match.params.id),  
        isActive: value.isActive,
        isLoginActive: true,
         agentId: localStorage.getItem('userId')

    };
    axios.post(`${API_URL}Client/InactiveClient`, payload, { headers })
        .then(response => {
            if (response.status === 200 && response.data.success) {
                this.setState({ isLoginDisable: false });
                onGetInClientDetail(this.props.match.params.clientId);
            } else {
                console.warn('Deactivation failed:', response.data);
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
}


  render() {
    const { clietDetail, deals, isResponsive } = this.props;
    const { selectedGroup } = this.state
   //
    return (
      <React.Fragment>
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
         
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
              <Row className="project-header">
                <Col sm="7">
             <Breadcrumbs
              title={this.props.t("Clients")}
              breadcrumbItem={this.props.t( " Manage client account")}
            />
            </Col>
            <Col sm="4" className="">
                <h2 className="">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                </Col>
            </Row>
           
            <Row>
          
            <Col xl="12">
            <Row>
                <Col sm="2"></Col>
				<Col sm="8">
					 <Card className="border-full mt-4"> 
                            <CardBody> 
                                <p className="font-size-16">There are 2 options to manage client accounts. You may choose one or both options depending on your needs.</p>    
                                <p className="font-size-16">Neither action deletes any data — all client records, notes, and history remain safely stored and can be restored at any time.</p>
                                <h3 className="font-size-18"><strong>De-Activate Client </strong></h3>
                                <p className="font-size-16">Use this if you no longer want to actively work with a client. Their status will change to inactive in your records, but you can re-activate them whenever needed.</p>
                                <h3 className="font-size-18"><strong>Disable Client Portal Access</strong></h3>
                                <p className="font-size-16">Use this if you want to stop a client from logging into their portal.</p>

                                <Row className="text-center text-sm-start"> {/* Center text on mobile, left on desktop */}
  <Col xs="12" sm="6" className="mb-2 d-flex justify-content-center justify-content-sm-end">
    {/* First Button Group */}
    {deals?.every(d => d.clientEngagementStatus > 1) ? (
      <>
        {clietDetail?.isActive ? (
          <RsLink 
            iconClass="bx bx bx-user-x"
            className="btn-google w-100 w-sm-auto"  // Full width mobile, auto on desktop
            onClick={() => this.deactivateClient(clietDetail)}
            isLoading={this.state.isLoading}
          >
            {this.state.isLoading ? 'Please wait...' : 'De-Activate Client'}
          </RsLink>
        ) : (
          <RsLink 
            iconClass="bx bx bx-user-x"
            className="btn-google w-100 w-sm-auto"
            onClick={() => this.activeClient(clietDetail)}
            isLoading={this.state.isLoading}
          >
            {this.state.isLoading ? 'Please wait...' : 'Activate Client'}
          </RsLink>
        )}
      </>
    ) : (
      <>
        <RsLink 
          iconClass="bx bx bx-user-x"
          className="btn-google w-100 w-sm-auto"
          disabled
        >
          De-Activate Client
        </RsLink>
        <br />
        <div className="clearfix"></div>
        <small className="d-block text-center text-sm-end">Active deals exist, account cannot be de-activated</small>
      </>
    )}
  </Col>

  <Col xs="12" sm="4" className="d-flex justify-content-center justify-content-sm-start">
    {/* Second Button Group */}
    {clietDetail?.userLogin?.userName === 'Not Authorized' ? (
      <RsLink 
        iconClass="bx bx-user-check"
        className="btn-google w-100 w-sm-auto"
        onClick={() => this.activeClientLogin(clietDetail)}
        isLoading={this.state.isLoginDisable}
      >
        {this.state.isLoginDisable ? 'Please wait...' : 'Enable Client Portal Access'}
      </RsLink>
    ) : (
      <RsLink 
        iconClass="bx bx-user-x"
        className="btn-google w-100 w-sm-auto"
        onClick={() => this.disableClientLogin(clietDetail)}
        isLoading={this.state.isLoginDisable}
      >
        {this.state.isLoginDisable ? 'Please wait...' : 'Disable Client Portal Access'}
      </RsLink>
    )}
  </Col>
</Row>
                              
                            </CardBody>
					</Card>
				</Col>
			</Row>


            </Col>
            
            </Row>
            </Col>
            </Row>
           
           

                      
         
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientActive.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  onGetClientDetail:PropTypes.func,
  onGetInClientDetail:PropTypes.func,
  clietDetail: PropTypes.object,
  deals: PropTypes.deals,
  onGetClientDeals:PropTypes.func,
  isResponsive:PropTypes.object

}

const mapStateToProps = ({ Clients }) => (
  {
    clietDetail: Clients.clietDetail,
    deals: Clients.deals,

  })

const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  onGetInClientDetail: clientId => dispatch(getInClientDetail(clientId)),
  onGetClientDeals: (agentId, clientId) => dispatch(getClientDeals(agentId, clientId)),
});
export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ClientActive))
